var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/chevron_blue.d78e182b.png","uri@2x": __webpack_public_path__ + "static/media/chevron_blue.d78e182b.png","uri@3x": __webpack_public_path__ + "static/media/chevron_blue.8bec9ed2.png",
    width: 16,
    height: 24
});